(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["download-mobile-app"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const body = document.body;

    // Function to detect Android or iOS
    function detectOS() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/android/i.test(userAgent)) {
            return "device-android";
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "device-ios";
        } else {
            return "device-other";
        }
    }

    // Add the OS class to the body element
    const osClass = detectOS();
    body.classList.add(osClass);



    const banner = document.querySelectorAll(".download-app")[0];
    const closeButton = document.querySelectorAll("[data-close-download-app]")[0];

    // Check localStorage to see if the banner should be hidden
    if (localStorage.getItem("downloadBannerClosed") === "true") {
        banner.classList.add("hidden");
    }

    // Add event listener to close the banner
    closeButton.addEventListener("click", function () {
        banner.classList.add("hidden"); // Hide the banner
        localStorage.setItem("downloadBannerClosed", "true"); // Save the user's choice
    });
  });

  } catch(e) { console.error(e); }
})();
})();
